import styled, { css } from 'styled-components';
import { Button } from '@usealloy/component-library';
import type { Operation } from 'flow/service/changelog/types';
import { getDiffColor, getDiffTint } from '../../../diffStyles';

export { getDiffColor };

export const StyledThresholdContent = styled.div<{
  isPreview?: boolean;
  diffStatus?: Operation;
}>`
  ${({ isPreview }) => (isPreview) && css`
    opacity: 0.5;
  `}
  ${({ diffStatus }) => {
    if (diffStatus) {
      return `
        background-color: ${getDiffTint(getDiffColor(diffStatus))};
        border-radius: 4px;
      `;
    }
    return '';
  }}
`;

export const StyledRuleMultiSelect = styled.div<{
  isInvalid?: boolean;
}>`
  ${({ isInvalid }) => (isInvalid && css`
    background-color: var(--cl-red-100);
    border-radius: var(--cl-radius-1);
`)};

  display: flex;
  align-items: center;
  margin-right: var(--cl-space-1);
  flex-shrink: 0;
  height: fit-content;

  > div {
    display: flex;
    align-items: center;
  }
`;

export const StyledEditableControlContainer = styled.div`
  display: flex;
  align-items: center;
  height: fit-content;
  margin: 0.5px 0 0 0;
  flex-wrap: wrap;
`;

export const StyledSwitchButton = styled(Button)`
  color: var(--cl-gray-800);
  height: var(--cl-line-height-3);
  white-space: nowrap;
  flex-shrink: 0;
  opacity: 1;
  pointer-events: auto;
  max-width: 100%;
  max-height: 100%;
  padding: 0 var(--cl-space-2);
  margin-left: var(--cl-space-2);
  transition: all 100ms ease;
  svg {
    width: var(--cl-font-size-1);
    height: var(--cl-font-size-1);
  }
`;
